import React from 'react';
import { getStatusColor, formatDate } from '../../../../utils/formatters/statusFormatters';
import { TransformedProject } from '../hooks/useProjects';

interface Props {
  projects: TransformedProject[];
  selectedProject: TransformedProject | null;
  onSelectProject: (project: TransformedProject) => void;
  clientFilter?: string | null;
}

export const ProjectList: React.FC<Props> = ({
  projects,
  selectedProject,
  onSelectProject,
}) => {
  return (
    <div className="divide-y divide-gray-200 dark:divide-gray-700">
      {projects.map((project) => (
        <div
          key={project.id}
          onClick={() => onSelectProject(project)} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onSelectProject(project); }} role="button" tabIndex={0}
          className={`px-6 py-4 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors ${
            selectedProject?.id === project.id
              ? 'bg-blue-50 dark:bg-blue-900/20 border-r-4 border-blue-500'
              : ''
          }`}
        >
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <div>
                <h4 className="text-sm font-medium text-gray-900 dark:text-white transition-colors">
                  {project.name}
                </h4>
                {project.jiraConfigured && (
                  <div className="flex items-center gap-1 mt-1">
                    <svg className="w-3 h-3 text-blue-600 dark:text-blue-400" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span
                      className="text-xs text-blue-600 dark:text-blue-400 font-medium"
                      title={`Jira integration active${
                        project.milestoneSource ? ` - Syncing ${project.milestoneSource.toLowerCase()}` : ''
                      }${
                        project.lastSync
                          ? `\nLast sync: ${new Date(project.lastSync).toLocaleString()}`
                          : '\nNever synced'
                      }`}
                    >
                      Jira syncing
                    </span>
                  </div>
                )}
              </div>
              {project.startDate && project.endDate && (
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-2 transition-colors">
                  {formatDate(project.startDate)} - {formatDate(project.endDate)}
                </p>
              )}
              <div className="flex items-center mt-2">
                <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2 mr-2 transition-colors">
                  <div
                    className="bg-blue-600 h-2 rounded-full"
                    style={{ width: `${project.progress}%` }}
                  />
                </div>
                <span className="text-xs text-gray-500 dark:text-gray-400 transition-colors">
                  {project.progress}%
                </span>
              </div>
            </div>
            <span className={`ml-2 px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(project.status)}`}>
              {project.status}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProjectList;
